<template>
    <v-layout justify-center align-center fill-height>
        <v-flex shrink align-center>
            <h1 class="display-3">
                500 Server Error
            </h1>
            <h3>Please try again later, we're offline for maintenence.</h3>
        </v-flex>
    </v-layout>
</template>
<script>
export default {}
</script>